import React from "react";

export const Skeleton = ({ className = "" }) => (
  <div className={`jn-skeleton ${className}`} aria-hidden="true" />
);

// Lignes de tableau (colonnes configurables)
export const SkeletonTableRows = ({ rows = 6, cols = 6, testid }) => (
  <div className="divide-y divide-slate-100" data-testid={testid}>
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-6 px-6 py-4">
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} className={`h-3.5 ${c === 0 ? "w-40" : c === cols - 1 ? "w-16 ml-auto" : "w-24"}`} />
        ))}
      </div>
    ))}
  </div>
);

// Grille de cartes
export const SkeletonCards = ({ count = 8, testid }) => (
  <div className="p-4 grid sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3" data-testid={testid}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="rounded-2xl border border-slate-200 bg-white p-4">
        <div className="flex items-center justify-between mb-3">
          <Skeleton className="h-4 w-16 rounded-full" />
          <Skeleton className="h-4 w-14" />
        </div>
        <Skeleton className="h-4 w-32 mb-2" />
        <Skeleton className="h-3 w-24 mb-3" />
        <Skeleton className="h-3 w-40" />
      </div>
    ))}
  </div>
);

// Bandeau de KPIs + zone graphique (Revenue / Statistiques)
export const SkeletonDashboard = ({ testid }) => (
  <div className="space-y-6" data-testid={testid}>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-slate-200 bg-white p-5">
          <Skeleton className="h-3 w-20 mb-3" />
          <Skeleton className="h-7 w-28" />
        </div>
      ))}
    </div>
    <div className="rounded-2xl border border-slate-200 bg-white p-6">
      <Skeleton className="h-4 w-40 mb-6" />
      <Skeleton className="h-56 w-full rounded-xl" />
    </div>
  </div>
);
